// Tickets de soporte: dudas sobre la plataforma, sin cliente, urgencia ni horas.
export const TICKET_TYPE_SUPPORT = "support";

const OPEN_SUPPORT_EVENT = "markezy:open-support";

// Todo el equipo interno (SERSEO y externas); el superadmin atiende las consultas.
export const canUseSupport = (user) =>
  ["superadmin", "agency_admin", "consultant"].includes(user?.role);

export const isSupportTicketNotification = (notification) =>
  notification?.ticket_type === TICKET_TYPE_SUPPORT;

// Abre el modal de soporte del header (no tiene ruta propia).
export const openSupportTicket = (ticketId = null) => {
  window.dispatchEvent(new CustomEvent(OPEN_SUPPORT_EVENT, { detail: { ticketId } }));
};

export const onOpenSupportTicket = (handler) => {
  const listener = (event) => handler(event.detail?.ticketId ?? null);
  window.addEventListener(OPEN_SUPPORT_EVENT, listener);
  return () => window.removeEventListener(OPEN_SUPPORT_EVENT, listener);
};
